import { system } from './system-core.esm.js';

// port from @styled-system/flexbox v.5.1.2
var config = {
  alignItems: true,
  alignContent: true,
  justifyItems: true,
  justifyContent: true,
  flexWrap: true,
  flexDirection: true,
  // item
  flex: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: true,
  justifySelf: true,
  alignSelf: true,
  order: true
};
var flexbox = system(config);

export default flexbox;
export { flexbox };
//# sourceMappingURL=flexbox.esm.js.map
